import { string } from "@src/libs/yup";

export default string()
	//.matches(/[a-zA-Z()'\-&,.]/, "Name is incorrect format")
	.required("Please enter a value");
